import { render, staticRenderFns } from "./view-files.vue?vue&type=template&id=5b942444&scoped=true&"
import script from "./view-files.vue?vue&type=script&lang=js&"
export * from "./view-files.vue?vue&type=script&lang=js&"
import style0 from "./view-files.vue?vue&type=style&index=0&id=5b942444&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b942444",
  null
  
)

export default component.exports